/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiEntityGroup,
    InternalApiEntityGroupFromJSON,
    InternalApiEntityGroupToJSON,
    InternalApiEntityGroupRecalculationFilter,
    InternalApiEntityGroupRecalculationFilterFromJSON,
    InternalApiEntityGroupRecalculationFilterToJSON,
    InternalApiEntityType,
    InternalApiEntityTypeFromJSON,
    InternalApiEntityTypeToJSON,
    InternalApiSegmentEvent,
    InternalApiSegmentEventFromJSON,
    InternalApiSegmentEventToJSON,
    InternalApiSegmentFeature,
    InternalApiSegmentFeatureFromJSON,
    InternalApiSegmentFeatureToJSON,
    InternalApiSegmentResult,
    InternalApiSegmentResultFromJSON,
    InternalApiSegmentResultToJSON,
} from '../models';

export interface AddEntityGroupRequest {
    internalApiEntityGroup: InternalApiEntityGroup;
}

export interface DeleteSegmentRequest {
    code: string;
}

export interface FindEntityGroupsRequest {
    entityType?: InternalApiEntityType;
    includeArchived?: boolean;
}

export interface FindSegmentEventsRequest {
    code: string;
    limit?: number;
}

export interface FindSegmentFeaturesRequest {
    code: string;
}

export interface FindSegmentResultsRequest {
    code: string;
    limit?: number;
}

export interface GetSegmentRequest {
    code: string;
}

export interface RecalculateEntityGroupRequest {
    groupId: number;
    internalApiEntityGroupRecalculationFilter?: InternalApiEntityGroupRecalculationFilter;
}

export interface UpdateEntityGroupRequest {
    groupId: number;
    internalApiEntityGroup: InternalApiEntityGroup;
}

/**
 * 
 */
export class EntityGroupsApi extends runtime.BaseAPI {

    /**
     * Adds new entity group
     */
    async addEntityGroupRaw(requestParameters: AddEntityGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiEntityGroup>> {
        if (requestParameters.internalApiEntityGroup === null || requestParameters.internalApiEntityGroup === undefined) {
            throw new runtime.RequiredError('internalApiEntityGroup','Required parameter requestParameters.internalApiEntityGroup was null or undefined when calling addEntityGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiEntityGroupToJSON(requestParameters.internalApiEntityGroup),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiEntityGroupFromJSON(jsonValue));
    }

    /**
     * Adds new entity group
     */
    async addEntityGroup(requestParameters: AddEntityGroupRequest, initOverrides?: RequestInit): Promise<InternalApiEntityGroup> {
        const response = await this.addEntityGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes Segment
     */
    async deleteSegmentRaw(requestParameters: DeleteSegmentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling deleteSegment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes Segment
     */
    async deleteSegment(requestParameters: DeleteSegmentRequest, initOverrides?: RequestInit): Promise<void> {
        await this.deleteSegmentRaw(requestParameters, initOverrides);
    }

    /**
     * Fetches entity groups
     */
    async findEntityGroupsRaw(requestParameters: FindEntityGroupsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiEntityGroup>>> {
        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.includeArchived !== undefined) {
            queryParameters['includeArchived'] = requestParameters.includeArchived;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiEntityGroupFromJSON));
    }

    /**
     * Fetches entity groups
     */
    async findEntityGroups(requestParameters: FindEntityGroupsRequest = {}, initOverrides?: RequestInit): Promise<Array<InternalApiEntityGroup>> {
        const response = await this.findEntityGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches Segment events
     */
    async findSegmentEventsRaw(requestParameters: FindSegmentEventsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiSegmentEvent>>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling findSegmentEvents.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups/{code}/events`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiSegmentEventFromJSON));
    }

    /**
     * Fetches Segment events
     */
    async findSegmentEvents(requestParameters: FindSegmentEventsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiSegmentEvent>> {
        const response = await this.findSegmentEventsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetches features that use associated Segment
     */
    async findSegmentFeaturesRaw(requestParameters: FindSegmentFeaturesRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiSegmentFeature>>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling findSegmentFeatures.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups/{code}/features`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiSegmentFeatureFromJSON));
    }

    /**
     * Fetches features that use associated Segment
     */
    async findSegmentFeatures(requestParameters: FindSegmentFeaturesRequest, initOverrides?: RequestInit): Promise<Array<InternalApiSegmentFeature>> {
        const response = await this.findSegmentFeaturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Entities that are part of the Segment
     */
    async findSegmentResultsRaw(requestParameters: FindSegmentResultsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Array<InternalApiSegmentResult>>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling findSegmentResults.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups/{code}/results`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(InternalApiSegmentResultFromJSON));
    }

    /**
     * Entities that are part of the Segment
     */
    async findSegmentResults(requestParameters: FindSegmentResultsRequest, initOverrides?: RequestInit): Promise<Array<InternalApiSegmentResult>> {
        const response = await this.findSegmentResultsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSegmentRaw(requestParameters: GetSegmentRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiEntityGroup>> {
        if (requestParameters.code === null || requestParameters.code === undefined) {
            throw new runtime.RequiredError('code','Required parameter requestParameters.code was null or undefined when calling getSegment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters.code))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiEntityGroupFromJSON(jsonValue));
    }

    /**
     */
    async getSegment(requestParameters: GetSegmentRequest, initOverrides?: RequestInit): Promise<InternalApiEntityGroup> {
        const response = await this.getSegmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Triggers entity group recalculation
     */
    async recalculateEntityGroupRaw(requestParameters: RecalculateEntityGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.groupId === null || requestParameters.groupId === undefined) {
            throw new runtime.RequiredError('groupId','Required parameter requestParameters.groupId was null or undefined when calling recalculateEntityGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups/{groupId}/recalculate`.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters.groupId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiEntityGroupRecalculationFilterToJSON(requestParameters.internalApiEntityGroupRecalculationFilter),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Triggers entity group recalculation
     */
    async recalculateEntityGroup(requestParameters: RecalculateEntityGroupRequest, initOverrides?: RequestInit): Promise<void> {
        await this.recalculateEntityGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Updates entity group
     */
    async updateEntityGroupRaw(requestParameters: UpdateEntityGroupRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiEntityGroup>> {
        if (requestParameters.groupId === null || requestParameters.groupId === undefined) {
            throw new runtime.RequiredError('groupId','Required parameter requestParameters.groupId was null or undefined when calling updateEntityGroup.');
        }

        if (requestParameters.internalApiEntityGroup === null || requestParameters.internalApiEntityGroup === undefined) {
            throw new runtime.RequiredError('internalApiEntityGroup','Required parameter requestParameters.internalApiEntityGroup was null or undefined when calling updateEntityGroup.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/entity-groups/{groupId}`.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters.groupId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiEntityGroupToJSON(requestParameters.internalApiEntityGroup),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiEntityGroupFromJSON(jsonValue));
    }

    /**
     * Updates entity group
     */
    async updateEntityGroup(requestParameters: UpdateEntityGroupRequest, initOverrides?: RequestInit): Promise<InternalApiEntityGroup> {
        const response = await this.updateEntityGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
